<bit-callout type="warning">
  {{ "disableSendExemption" | i18n }}
</bit-callout>

<bit-form-control>
  <input type="checkbox" bitCheckbox [formControl]="enabled" id="enabled" />
  <bit-label>{{ "turnOn" | i18n }}</bit-label>
</bit-form-control>
